// 用于匹配跳转H5页面->需要手动配置,并非最好方案,较好的方案可以模仿云课堂的调整,通过匹配跳转路由规则,进行自适应跳转
export function browserRedirect(url) {
  let is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
  let env = process.env.NODE_ENV
  let preUrl = "https://mlib.yiihuu.com/library/#"
  if (env == 'production') {
    preUrl="https://mlib.yiihuu.com/library/#"
  } else {
    preUrl="http://mlib.test.yiihuu.com:81/library/#"
  }
  if (is_mobi) {
    location.href = preUrl.concat(url);
  }
}

export function browserRedirectHome(url) {
  let is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
  let env = process.env.NODE_ENV
  let preUrl = "https://mlib.yiihuu.com"
  if (env == 'production') {
    preUrl="https://mlib.yiihuu.com"
  } else {
    preUrl="http://mlib.test.yiihuu.com:81"
  }
  if (is_mobi) {
    location.href = preUrl.concat(url);
  }
}

export function browserRedirectLib(url) {
  let is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
  let env = process.env.NODE_ENV
  let preUrl = "https://mlib.yiihuu.com/lib/#"
  if (env == 'production') {
    preUrl="https://mlib.yiihuu.com/lib/#"
  } else {
    preUrl="http://mlib.test.yiihuu.com:81/lib/#"
  }
  if (is_mobi) {
    location.href = preUrl.concat(url);
  }
}